var map = {
	"./healthBehaviours.png": "3258",
	"./healthWellbeing.png": "4186",
	"./howToReadCharts/distribution.png": "f85e",
	"./howToReadCharts/dotPlot.png": "33fe",
	"./howToReadCharts/healthEquity.png": "8de2",
	"./howToReadCharts/indexedLine.png": "01bd",
	"./howToReadCharts/populationPyramid.png": "b27f",
	"./howToReadCharts/rankedBar.png": "3330",
	"./howToReadCharts/regionCompare.png": "5740",
	"./howToReadCharts/thermometer.png": "560f",
	"./howToReadCharts/waffle.png": "eab0",
	"./livingConditions.png": "e058",
	"./logo.png": "cf05",
	"./mentalHealth.png": "16e7",
	"./print/images/intro.png": "31bd",
	"./print/images/sideImg.png": "3e8c",
	"./print/images/titleFooter.png": "9b15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";